<div class="relative inline-block min-w-[60px]">
  <button
    type="button"
    class="flex items-center gap-2 px-2 py-1 bg-transparent hover:bg-gray-50 rounded transition-colors cursor-pointer focus:outline-none text-gray-700"
    (click)="toggle()"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-haspopup]="true"
  >
    <span class="text-base font-medium">{{ getDisplayValue() }}</span>
    <svg 
      class="w-4 h-4 text-gray-500 transition-transform duration-200"
      [class.rotate-180]="isOpen()"
      fill="none" 
      stroke="currentColor" 
      viewBox="0 0 24 24"
    >
      <path 
        stroke-linecap="round" 
        stroke-linejoin="round" 
        stroke-width="2" 
        d="M19 9l-7 7-7-7"
      ></path>
    </svg>
  </button>
  @if (isOpen()) {
    <div class="absolute z-50 mt-1 min-w-[80px] bg-white rounded-md shadow-sm">
      <ul class="py-1 max-h-48 overflow-y-auto">
        @for (option of options; track option) {
          <li>
            <button
              type="button"
              class="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-primary-g100 focus:outline-none focus:bg-primary-g100 transition-colors"
              [class.bg-primary-g100]="selectedValue() === option"
              [class.text-gray-900]="selectedValue() === option"
              [class.font-medium]="selectedValue() === option"
              (click)="selectOption(option)"
            >
              {{ option }}
            </button>
          </li>
        }
      </ul>
    </div>
  }
</div>